<template>
  <v-layout column>
    <v-layout column v-if="eventType === 'TaxReturnIdentityVerificationPassed'">
      <div class="pb-2 text-xs-left green--text">
        <v-icon color="green" small>done</v-icon>
        <b>Identity verification passed</b>
      </div>

      <ul class="px-3">
        <li>
          <b>Identity verification ID</b>:
          {{ eventPayload.tax_return_identity_verification_id }}
        </li>
        <li><b>IP address</b>: {{ eventPayload.ip_address }}</li>
        <li>
          <b>Verification method</b>: {{ eventPayload.verification_method }}
        </li>
        <li><b>Phone number</b>: {{ eventPayload.phone_number }}</li>
        <li><b>Session ID</b>: {{ eventPayload.session_id }}</li>
      </ul>
    </v-layout>

    <v-layout column v-else-if="eventType === 'TaxReturnSignatureAdded'">
      <v-layout class="signature-container">
        <span class="signature-label">Signature</span>
        <img
          v-if="eventPayload.signature_type === 'image'"
          :src="eventPayload.signature_data"
          alt="Signature"
        />
        <v-layout v-else class="signature-text" align-center justify-center>
          <span>{{ eventPayload.signature_data }}</span>
        </v-layout>
      </v-layout>

      <ul class="px-3">
        <li>
          <b>Form</b>: {{ eventPayload.form_name }} -
          {{ eventPayload.form_id }} (Page: {{ eventPayload.form_page }})
        </li>
        <li><b>Title</b>: {{ eventPayload.signature_title }}</li>
        <li><b>IP address</b>: {{ eventPayload.ip_address }}</li>
        <li><b>Session ID</b>: {{ eventPayload.session_id }}</li>
      </ul>
    </v-layout>

    <v-layout column v-else-if="eventType === 'TaxReturnDelivered'">
      <ul class="px-3">
        <li><b>Recipient email</b>: {{ eventPayload.recipient_email }}</li>
        <li>
          <b>Identity verification required</b>:
          {{ eventPayload.identity_verification_enabled ? 'Yes' : 'No' }}
        </li>
        <li><b>Delivered by</b>: {{ eventPayload.delivered_by }}</li>
      </ul>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    eventType: {
      type: String,
      required: true,
    },

    eventPayload: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },
};
</script>

<style scoped>
.signature-container {
  max-width: 200px;
  margin-bottom: 16px;
  border: 1px solid var(--gray-400);
  position: relative;
}

.signature-label {
  position: absolute;
  top: -9px;
  left: 10px;
  background-color: white;
  font-size: 12px;
}

.signature-container img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.signature-text {
  overflow: auto;
  padding: 12px 0px;
  font-size: 24px;
  font-family: 'Zeyada', cursive;
  white-space: nowrap;
}
</style>
